import { ISubjectKind } from 'APIPackage/DictionariesModule/interfaces/ISubjectKind';

import { makeCreateDictionarySelectOption } from './makeCreateDictionarySelectOption';

export const createDictionarySubjectKindSelectOption = makeCreateDictionarySelectOption<ISubjectKind>('id', 'title');
